<p-progressBar mode="indeterminate" *ngIf="loading()"></p-progressBar>

<app-page-shell>
    <app-page-detail-hero [auditStamp]="location() ? {
                createdAt: location()?.createdAt,
                createdBy: location()?.createdBy,
                createdByActor: location()?.createdByActor,
                updatedAt: location()?.updatedAt,
                updatedBy: location()?.updatedBy,
                updatedByActor: location()?.updatedByActor
            } : null"
        icon="fa-solid fa-map-location-dot"
        eyebrow="Operations Setup"
        [title]="title()"
        [subtitle]="subtitle()">
        <div tags>
            <p-tag [value]="locationTypeLabel()" severity="info"></p-tag>
            <p-tag [value]="statusLabel()" severity="success"></p-tag>
        </div>
        <div actions>
            <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" (onClick)="back()"></p-button>
            <p-button label="Edit" icon="pi pi-pencil" (onClick)="edit()" [disabled]="!location()?.id"></p-button>
        </div>
    </app-page-detail-hero>

    <section class="view-grid" *ngIf="location() as current">
        <app-page-data-panel title="Location Details" subtitle="Master location identity and address.">
            <div class="facts">
                <div><span>Name</span><strong>{{ current.name || '-' }}</strong></div>
                <div><span>Code</span><strong>{{ locationCode() }}</strong></div>
                <div><span>Location Type</span><strong>{{ current.locationType || '-' }}</strong></div>
                <div><span>Owning Company</span><strong>{{ current.company?.name || companyName() }}</strong></div>
                <div><span>Country</span><strong>{{ current.country?.name || '-' }}</strong></div>
                <div><span>City</span><strong>{{ cityLabel() }}</strong></div>
                <div class="wide"><span>Address</span><strong>{{ addressLabel() || '-' }}</strong></div>
                <div class="wide"><span>Coordinates</span><strong>{{ coordinatesLabel() }}</strong></div>
            </div>
        </app-page-data-panel>

        <app-page-data-panel title="Location Map" subtitle="Simple coordinate preview for the current location.">
            <div class="map-panel" *ngIf="hasCoordinates(); else noMapCoordinates">
                <iframe class="map-frame" [src]="mapUrl()" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                <div class="map-meta">
                    <span>{{ coordinatesLabel() }}</span>
                    <p-button label="Open in Google Maps" icon="pi pi-external-link" severity="secondary" [outlined]="true" (onClick)="openExternalMap()"></p-button>
                </div>
            </div>
            <ng-template #noMapCoordinates>
                <div class="empty-panel-state">
                    <strong>No map preview available</strong>
                    <span>Add latitude and longitude to render the location map.</span>
                </div>
            </ng-template>
        </app-page-data-panel>

        <app-page-data-panel title="Contacts" subtitle="Default contact and contacts with access.">
            <div class="facts">
                <div class="wide"><span>Default Contact</span><strong>{{ defaultContactLabel() }}</strong></div>
                <div class="wide"><span>Contacts With Access</span><strong>{{ contactsSummary() }}</strong></div>
            </div>
        </app-page-data-panel>

        

        <app-page-data-panel title="Association & Type" subtitle="Operational ownership and classification.">
            <div class="facts">
                <div><span>Owning Company</span><strong>{{ current.company?.name || '-' }}</strong></div>
                <div><span>Retailer / Store Chain</span><strong>{{ current.retailer?.name || '-' }}</strong></div>
                <div><span>Location Type</span><strong>{{ current.locationType || '-' }}</strong></div>
                <div><span>Record ID</span><strong>{{ current.id || '-' }}</strong></div>
            </div>
        </app-page-data-panel>

        <app-page-data-panel title="Merchandiser CRM Client Account Map" subtitle="Client, account, and merchandiser assignments attached to this location.">
            <div class="assignment-list" *ngIf="merchandiserAssignments().length; else noAssignments">
                <div class="assignment-card" *ngFor="let assignment of merchandiserAssignments()">
                    <div><span>CRM Client</span><strong>{{ merchandiserAssignmentClientLabel(assignment) }}</strong></div>
                    <div><span>CRM Account</span><strong>{{ merchandiserAssignmentAccountLabel(assignment) }}</strong></div>
                    <div><span>Merchandiser</span><strong>{{ merchandiserAssignmentMerchandiserLabel(assignment) }}</strong></div>
                    <div><span>Assignment</span><strong>{{ merchandiserAssignmentRoleLabel(assignment) }}</strong></div>
                </div>
            </div>
            <ng-template #noAssignments>
                <div class="empty-panel-state">
                    <strong>No merchandiser mapping</strong>
                    <span>This location does not currently have CRM client/account merchandiser assignments.</span>
                </div>
            </ng-template>
        </app-page-data-panel>

    </section>
</app-page-shell>
